module.exports = __webpack_public_path__ + "img/2011-1.62cb7705.jpg";